<div class="assign-box u-p24" [ngStyle]="styles">
    <div class="assign-box-title-container">
        <span (click)="hide()" class="fa-regular fa-xmark assign-box-close-button"></span>
        <h2 class="assign-box-title">Email Template</h2>
        <p>
            Add and save a message as a template. New information can be added prior to sending the
            template as an email.
        </p>
    </div>

    <form [formGroup]="templateForm">
        <div class="aix-flex-grid aix-form__container u-mt16">
            <div class="aix-form__group">
                <aix-input
                    formControlName="name"
                    [data-testing]="'templateName'"
                    [isDisabled]="false"
                    [isRequired]="true"
                    [isValid]="!!templateForm.get('name')?.valid"
                >
                    Template Name
                </aix-input>
            </div>
            <div class="aix-form__group">
                <aix-input
                    formControlName="subject"
                    [data-testing]="'templateSubject'"
                    [isDisabled]="false"
                    [isRequired]="true"
                    [isValid]="!!templateForm.get('subject')?.valid"
                >
                    Subject
                </aix-input>
            </div>
            <div class="aix-form__group">
                @if (useRichText()) {
                <aix-rich-text
                    formControlName="body"
                    [data-testing]="'templateBody'"
                    [isDisabled]="false"
                    [isRequired]="true"
                    [isValid]="!!templateForm.get('body')?.valid"
                >
                    Message
                </aix-rich-text>
                } @else {
                <aix-textarea
                    formControlName="body"
                    [data-testing]="'templateBody'"
                    [height]="192"
                    [isDisabled]="false"
                    [isRequired]="true"
                    [isValid]="!!templateForm.get('body')?.valid"
                >
                    Message
                </aix-textarea>
                }
            </div>
            <div class="aix-form__group">
                <aix-checkbox
                    formControlName="isPrimary"
                    [data-testing]="'templateIsPrimary'"
                    [isValid]="true"
                    [isRequired]="false"
                    [description]="checkboxDescription()"
                >
                    Set as primary template
                </aix-checkbox>
            </div>
        </div>
    </form>

    <ng-content></ng-content>

    <div class="aix-toolbar">
        <aix-button
            [data-testing]="'cancel-button'"
            (click)="hide()"
            [buttonType]="cancelButtonType"
            [buttonLabel]="'Cancel'"
        >
        </aix-button>
        <aix-button
            [data-testing]="'save-button'"
            [isDisabled]="!templateForm.valid"
            (click)="saveTemplate()"
            [buttonLabel]="'Save'"
        >
        </aix-button>
    </div>
</div>
